import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import FormUtils from '../../utils/formUtils';

const withForm = WrappedForm => {
  const form = reduxForm()(WrappedForm);

  return connect((state, props) => {
    return {
      initialValues: FormUtils.getFormValues(props.fields, props.config.fields)
    };
  })(form);
};

export default withForm;



// WEBPACK FOOTER //
// ./src/components/hocs/withForm.js